import axios from "./api";
class AdmissionRequestService {
  getAll() {
    return axios.get(`/admissionRequests`);
  }  
  getArchivated() {
    return axios.get('getOldAdmissionRequests');
  }
  getUserAdmissionRequests() {
    return axios.get('getUserAdmissionRequests');
  }

  get(id) {
    return axios.get(`/admissionRequests/${id}`);
  }
  create(data) {
    return axios.post(`/admissionRequests`, data);
  }
  saveStep(data) {
    return axios.post(`/admissionRequests/saveStep`, data);
  }
  update(id, data) {
    return axios.put(`/admissionRequests/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/admissionRequests/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AdmissionRequestService();
